import AbstractSubscriptionForm from "./AbstractSubscriptionForm";
import { LOADER_CONFIG } from "../assets/_loaderConfig";

const SUBSCRIBE_INPUT_CLIENT_ID_CLASS = "js-subscribe-input-client_id";
const SUBSCRIBE_INPUT_TYPE_CLASS = "js-subscribe-type";
const SUBSCRIBE_INPUT_REASON = "js-unsubscribe-input-reason";
const SUBSCRIBE_TEXTAREA_CLASS = "js-subscribe-textarea";
const SUBSCRIBE_BUTTON_CLASS = "js-subscribe-btn";

/**
 * Форма отписки на рассылку на странице unsubscribe page
 */
export default class UnsubscribePageForm extends AbstractSubscriptionForm {
    constructor(formElem) {
        super(formElem);
        this.url = LOADER_CONFIG.api_unsubscribe.url;
    }

    _setElems() {
        this._inputClientIdElem = this.elem.querySelector(
            `.${SUBSCRIBE_INPUT_CLIENT_ID_CLASS}`,
        );
        this._inputTypeElem = this.elem.querySelector(
            `.${SUBSCRIBE_INPUT_TYPE_CLASS}`,
        );
        this._radioElems = this.elem.querySelectorAll(
            `.${SUBSCRIBE_INPUT_REASON}`,
        );
        this._textareaElem = this.elem.querySelector(
            `.${SUBSCRIBE_TEXTAREA_CLASS}`,
        );
        this._btnElem = this.elem.querySelector(`.${SUBSCRIBE_BUTTON_CLASS}`);
    }

    _toggleDisable(isDisable = true) {
        this._textareaElem.disabled = isDisable;
        this._btnElem.disabled = isDisable;
        this._radioElems.forEach(
            (_radioElem) => (_radioElem.disabled = isDisable),
        );
    }

    _getBody() {
        const body = Array.from(this._radioElems).reduce((item, reason) => {
            if (reason.children[0].checked) {
                item["reason"] =
                    reason.children[0].value === "state_your_reason"
                        ? this._textareaElem.value
                        : reason.children[1].innerHTML;
            }
            return item;
        }, {});

        body.client_id = this._inputClientIdElem.value;
        body.news_id = this._inputTypeElem.value;

        return body;
    }

    _reset() {
        this._textareaElem.value = "";
    }
}
